export default function MiastoModal({
	isOpen,
	editingItem,
	formName,
	setFormName,
	formPowiatId,
	formPowiatName,
	onOpenPowiatSelect,
	formWojewodztwoId,
	formWojewodztwoName,
	onOpenWojewodztwoSelect,
	formGminaId,
	formGminaName,
	onOpenGminaSelect,
	isSaving,
	onClose,
	onSubmit,
}) {
	if (!isOpen) return null

	return (
		<div className="fixed inset-0 z-50 flex items-center justify-center p-4">
			<div className="absolute inset-0 bg-black/40" onClick={onClose} />
			<div className="relative w-full max-w-md rounded-lg bg-white shadow-xl">
				<form onSubmit={onSubmit} className="p-5">
					<h3 className="text-base font-semibold text-gray-900">
						{editingItem ? 'Edytuj miasto' : 'Dodaj miasto'}
					</h3>
					<p className="mt-1 text-sm text-gray-500">
						{editingItem ? 'Zaktualizuj nazwe miasta.' : 'Wprowadz nazwe nowego miasta.'}
					</p>

					<div className="mt-4">
						<label htmlFor="miasto-nazwa" className="block text-sm font-medium text-gray-700">
							Nazwa
						</label>
						<input
							id="miasto-nazwa"
							type="text"
							value={formName}
							onChange={e => setFormName(e.target.value)}
							required
							autoFocus
							className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:border-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
						/>
					</div>

					<div className="mt-4">
						<div className="flex items-center justify-between">
							<label className="block text-sm font-medium text-gray-700">Powiat</label>
							<button
								type="button"
								onClick={onOpenPowiatSelect}
								className="rounded-md border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50">
								Wybierz z listy
							</button>
						</div>
						<div className="mt-1 min-h-10 rounded-md border border-gray-300 bg-gray-50 px-3 py-2 text-sm text-gray-700">
							{formPowiatId ? formPowiatName || formPowiatId : 'Nie wybrano powiatu'}
						</div>
					</div>

					<div className="mt-4">
						<div className="flex items-center justify-between">
							<label className="block text-sm font-medium text-gray-700">Wojewodztwo</label>
							<button
								type="button"
								onClick={onOpenWojewodztwoSelect}
								className="rounded-md border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50">
								Wybierz z listy
							</button>
						</div>
						<div className="mt-1 min-h-10 rounded-md border border-gray-300 bg-gray-50 px-3 py-2 text-sm text-gray-700">
							{formWojewodztwoId
								? formWojewodztwoName || formWojewodztwoId
								: 'Nie wybrano wojewodztwa'}
						</div>
					</div>

					<div className="mt-4">
						<div className="flex items-center justify-between">
							<label className="block text-sm font-medium text-gray-700">Gmina</label>
							<button
								type="button"
								onClick={onOpenGminaSelect}
								className="rounded-md border border-gray-300 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50">
								Wybierz z listy
							</button>
						</div>
						<div className="mt-1 min-h-10 rounded-md border border-gray-300 bg-gray-50 px-3 py-2 text-sm text-gray-700">
							{formGminaId ? formGminaName || formGminaId : 'Nie wybrano gminy'}
						</div>
					</div>

					<div className="mt-5 flex justify-end gap-2">
						<button
							type="button"
							onClick={onClose}
							className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50">
							Anuluj
						</button>
						<button
							type="submit"
							disabled={
								isSaving || !formName.trim() || !formPowiatId || !formWojewodztwoId || !formGminaId
							}
							className="rounded-md bg-indigo-600 px-3 py-2 text-sm font-medium text-white hover:bg-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-400">
							{isSaving ? 'Zapisywanie...' : editingItem ? 'Zapisz zmiany' : 'Utworz'}
						</button>
					</div>
				</form>
			</div>
		</div>
	)
}
